import React from "react";
// import PropTypes from 'prop-types';
import { withGesture } from "react-with-gesture";
import { Spring, animated } from "react-spring";

export const Swipable = props => {
  const { xDelta, down, children } = props;
  const { onLeft, onRight } = props;

  // if (!down && xDelta < 0) onLeft();
  const buffer = 100;
  const touchEnd = () => {
    if (xDelta < -buffer) onRight();
    if (xDelta > buffer) onLeft();
  };

  return (
    <Spring
      native
      to={{ x: down ? xDelta : 0 }}
      immediate={name => down && name === "x"}
    >
      {({ x }) => (
        <animated.div
          className="item"
          // style={{ backgroundColor: xDelta < 0 ? "#14D790" : "#FF1C68" }}
          style={{
            backgroundColor: x
              .interpolate({
                map: Math.abs,
                range: [0, buffer],
                output: [0, 1],
                extrapolate: "clamp",
              })
              .interpolate(
                x =>
                  xDelta < 0
                    ? `rgba(20, 215, 144, ${x})`
                    : `rgba(255, 28, 104, ${x})`
              ),
          }}
        >
          {/* <animated.div
            className="bubble"
            style={{
              transform: x
                .interpolate({
                  map: Math.abs,
                  range: [50, 300],
                  output: [0.5, 1],
                  extrapolate: "clamp",
                })
                .interpolate(x => `scale(${x})`),
              justifySelf: xDelta < 0 ? "end" : "start",
            }}
          /> */}
          <animated.div
            className="fg"
            style={{ transform: x.interpolate(x => `translate3d(${x}px,0,0)`) }}
            onMouseUp={touchEnd}
            onTouchEnd={touchEnd}
          >
            {children}
            {/* {false && down && Math.abs(xDelta) > 50
              ? xDelta < 0 ? "Cancel" : "Accept"
              : children} */}
          </animated.div>
        </animated.div>
      )}
    </Spring>
  );
};

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// Swipable.propTypes = {

// };

export default withGesture(Swipable);



// WEBPACK FOOTER //
// ./src/Swipable.js